<template>
  <div class="messenger-chat">
    <div class="messenger-chat__header">
      <chat-header />
    </div>
    <div class="messenger-chat__body">
      <chat-window />
    </div>
    <div class="messenger-chat__footer">
      <chat-send />
    </div>
  </div>
</template>

<script>
import ChatHeader from './chat-header/ChatHeader.vue'
import ChatSend from './message-send/ChatSend.vue'
import ChatWindow from './chat-window/ChatWindow.vue'

export default {
  components: {
    ChatHeader,
    ChatSend,
    ChatWindow
  }
}
</script>
